import { useIsMobile } from '../../../hooks/useIsMobile';

type PieSize = 'default' | 'small' | 'xs';

export const useGetPieDimensions = (size: PieSize = 'default') => {
  const isMobile = useIsMobile();

  if (size === 'xs') {
    const chartHeight = isMobile ? 80 : 100;
    const innerRadius = isMobile ? 22 : 28;
    const outerRadius = isMobile ? 36 : 45;
    return { chartHeight, innerRadius, outerRadius };
  }

  if (size === 'small') {
    const chartHeight = isMobile ? 120 : 140;
    const innerRadius = isMobile ? 35 : 40;
    const outerRadius = isMobile ? 55 : 65;
    return { chartHeight, innerRadius, outerRadius };
  }

  const chartHeight = isMobile ? 200 : 250;
  const innerRadius = isMobile ? 60 : 70;
  const outerRadius = isMobile ? 100 : 120;
  return { chartHeight, innerRadius, outerRadius };
};
